(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function handleAutocorrect() {
		// Handles the cases where we automatically cancel the current search and do a new search because we had no results
		// See flow-chart at https://wiki.swisscom.com/display/PD/Workflow
		return function autocorrectHandler(data, configuration, callback) {
			// Only correct automatically if no results
			if(data.resultCount) {
				return callback();
			}

			// Don’t do automatic corrections after first iteration
			if('autoCorrectedFrom' in configuration) {
				return callback();
			}

			var suggestions = data.spellingSuggestions || [];

			// Don’t do anything if no suggestions found
			if(!suggestions || !suggestions.length) {
				return callback();
			}

			var processor = this.processor;
			var firstSuggestion = suggestions[0];
			// Send a new query with the same config but the autocorrected query
			var config = search.util.extend({}, configuration.inputConfig, {
				autoCorrectedFrom: configuration.query,
				nextSuggestion: suggestions.length > 1 ? suggestions[1].plain : null,
				subsearch: true,
				query: firstSuggestion.plain
			});
			processor.track('automaticSpellingCorrection', search.util.extend({}, configuration, {
				query: firstSuggestion.plain,
				previousQuery: configuration.query
			}));

			this.abort(true);
			processor.process(config);
		};
	}

	function addManualCorrection() {
		// Adds a property manualCorrectionSuggestion to the returned configuration.
		// Should be added after the handleAutocorrect filter.
		return function manualCorrectionAdder(data, configuration, callback) {
			var suggestions = data.spellingSuggestions || [];

			// Don’t do anything if no suggestions found
			if(!suggestions.length && !configuration.nextSuggestion) {
				return callback();
			}

			// Take the nextSuggestion (2nd place before) from a previous, auto-corrected search
			// or, alternatively, the current top suggestion
			var suggestionText = configuration.nextSuggestion;
			if(!suggestionText) {
				suggestionText = suggestions[0].plain;
			}
			configuration.manualCorrectionSuggestion = suggestionText;

			callback();
		};
	}

	function setUp(processor, autocorrectHandler, manualCorrectionAdder, weight) {
		weight = weight || 100;
		processor.usePost(autocorrectHandler||handleAutocorrect(), weight);
		processor.usePost(manualCorrectionAdder||addManualCorrection(), weight+20);
	}

	var plugins = search.plugins = search.plugins || {};
	var spellchecking = plugins.spellchecking = plugins.spellchecking || {};

	spellchecking.handleAutocorrect = handleAutocorrect;
	spellchecking.addManualCorrection = addManualCorrection;
	spellchecking.setUp = setUp;

})(window.SCS = window.SCS || {});


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/spellchecking.js
// module id = 58
// module chunks = 0